var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _c("div", { staticClass: "d-flex justify-content-between mb-3" }, [
            _c("div", { staticClass: "d-flex" }, [
              _c(
                "div",
                { staticClass: "mr-2" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", plain: "" },
                      on: { click: _vm.voltar }
                    },
                    [
                      _c("i", { staticClass: "fas fa-arrow-left" }),
                      _vm._v("\n            Voltar\n          ")
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex items-center" },
                [
                  _c(
                    "el-tag",
                    { staticClass: "mr-2", attrs: { type: "info" } },
                    [_c("i", { staticClass: "fas fa-users fa-1x" })]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "font-weight-semibold mb-0" }, [
                    _vm._v("Propostas Varejo")
                  ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex align-items-center" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.pedidosVarejo }
                  },
                  [
                    _c("i", { staticClass: "fas fa-shopping-cart" }),
                    _vm._v("\n          Pedidos Varejo\n        ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", size: "small", plain: "" },
                    on: { click: _vm.addProposta }
                  },
                  [
                    _c("i", { staticClass: "fas fa-plus" }),
                    _vm._v(" \n          Adicionar Proposta\n        ")
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            { attrs: { "label-position": "top" } },
            [
              _c(
                "el-row",
                {
                  staticClass: "mb-3 bg-red",
                  attrs: { type: "flex", gutter: 12, align: "bottom" }
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 3 } },
                    [
                      _c("label", [_vm._v("Proposta")]),
                      _vm._v(" "),
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "Código da proposta"
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.getPropostas()
                          }
                        },
                        model: {
                          value: _vm.filtro.id,
                          callback: function($$v) {
                            _vm.$set(_vm.filtro, "id", $$v)
                          },
                          expression: "filtro.id"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c("label", [_vm._v("Cliente")]),
                      _vm._v(" "),
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "Código ou nome do cliente"
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.getPropostas()
                          }
                        },
                        model: {
                          value: _vm.filtro.proposta,
                          callback: function($$v) {
                            _vm.$set(_vm.filtro, "proposta", $$v)
                          },
                          expression: "filtro.proposta"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c("label", [_vm._v("Tipo")]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "small",
                            placeholder: "Tipo",
                            disabled: _vm.isLoading,
                            filterable: ""
                          },
                          model: {
                            value: _vm.filtro.tipo,
                            callback: function($$v) {
                              _vm.$set(_vm.filtro, "tipo", $$v)
                            },
                            expression: "filtro.tipo"
                          }
                        },
                        _vm._l(_vm.optionsTipo, function(type) {
                          return _c("el-option", {
                            key: type.value,
                            attrs: { label: type.text, value: type.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c("label", [_vm._v("Classificação Bonificação")]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "small",
                            placeholder: "Classificação",
                            disabled: _vm.isLoading
                          },
                          model: {
                            value: _vm.filtro.classificacao_bonificacao,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.filtro,
                                "classificacao_bonificacao",
                                $$v
                              )
                            },
                            expression: "filtro.classificacao_bonificacao"
                          }
                        },
                        _vm._l(_vm.optionsClassificacaoBonificacao, function(
                          classificacao
                        ) {
                          return _c("el-option", {
                            key: classificacao.value,
                            attrs: {
                              label: classificacao.text,
                              value: classificacao.value
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", disabled: _vm.isLoading },
                          on: {
                            click: function($event) {
                              return _vm.getPropostas()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fas fa-search" }),
                          _vm._v("\n                Buscar\n            ")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between"
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "mini", disabled: _vm.isLoading },
                      on: {
                        change: function($event) {
                          return _vm.getPropostas()
                        }
                      },
                      model: {
                        value: _vm.filtro.status,
                        callback: function($$v) {
                          _vm.$set(_vm.filtro, "status", $$v)
                        },
                        expression: "filtro.status"
                      }
                    },
                    _vm._l(_vm.options, function(stat) {
                      return _c(
                        "el-radio-button",
                        { key: stat.text, attrs: { label: stat.value } },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c(
                                "el-tag",
                                {
                                  staticClass: "mr-1",
                                  attrs: {
                                    type:
                                      stat.text == "Todos"
                                        ? ""
                                        : stat.text == "Aprovado"
                                        ? "success"
                                        : stat.text == "Aberto"
                                        ? "warning"
                                        : "danger",
                                    size: "mini"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                          " +
                                      _vm._s(
                                        _vm.filtro.status == stat.value
                                          ? _vm.filtro.total
                                          : 0
                                      ) +
                                      "\n                      "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "ml-1" }, [
                                _vm._v(_vm._s(stat.text))
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _vm.isLoading
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "border rounded p-3 d-flex align-items-center"
                        },
                        [
                          _c("i", { staticClass: "el-icon-loading mr-2" }),
                          _vm._v(
                            "\n            Carregando propostas...\n        "
                          )
                        ]
                      )
                    : !_vm.isLoading && _vm.propostas.length > 0
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "rounded",
                              attrs: {
                                "empty-text": "Nenhuma proposta encontrada.",
                                data: _vm.propostas,
                                align: "center",
                                border: "",
                                "row-key": "id",
                                size: "mini"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "ID",
                                  width: "90",
                                  prop: "id",
                                  align: "left"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return _c("div", {}, [
                                        _vm._v(_vm._s(scope.row.id))
                                      ])
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "#Código",
                                  width: "110",
                                  align: "center"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.codigo))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  "min-width": "320",
                                  label: "Cliente",
                                  align: "left"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.nome))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Tipo Proposta",
                                  width: "120",
                                  align: "left"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type:
                                                scope.row.tipo_proposta ==
                                                "VENDA"
                                                  ? "success"
                                                  : scope.row.tipo_proposta ==
                                                    "AMOSTRA"
                                                  ? "warning"
                                                  : scope.row.tipo_proposta ==
                                                    "BONIFICACAO"
                                                  ? ""
                                                  : "info",
                                              size: "small"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.tipo_proposta)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        scope.row.classificacao_bonificacao
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "font-size": "11px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.textoClassificacao(
                                                        scope.row
                                                          .classificacao_bonificacao
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Situação/Status",
                                  width: "130",
                                  align: "left"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        scope.row.status
                                          ? _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  type: "info",
                                                  size: "small",
                                                  type:
                                                    scope.row.status ===
                                                    "ABERTO"
                                                      ? ""
                                                      : scope.row.status ==
                                                        "APROVADO"
                                                      ? "success"
                                                      : "danger"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(scope.row.status) +
                                                    "\n                      "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Criado em",
                                  width: "130",
                                  align: "center"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center justify-content-center"
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-time"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "ml-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatDate(
                                                      scope.row.created_at,
                                                      "DD/MM/YYYY"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "valor_bruto",
                                  label: "Valor Bruto",
                                  width: "110"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              scope.row.valor_bruto
                                                ? "R$ " +
                                                    parseFloat(
                                                      scope.row.valor_bruto
                                                    )
                                                      .toFixed(2)
                                                      .toString()
                                                      .replace(".", ",")
                                                : "-"
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "valor_desconto",
                                  label: "Desconto",
                                  width: "110"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              scope.row.valor_desconto
                                                ? "R$ " +
                                                    parseFloat(
                                                      scope.row.valor_desconto
                                                    )
                                                      .toFixed(2)
                                                      .toString()
                                                      .replace(".", ",")
                                                : "-"
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "valor",
                                  label: "Total",
                                  width: "110"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              scope.row.valor
                                                ? "R$ " +
                                                    parseFloat(scope.row.valor)
                                                      .toFixed(2)
                                                      .toString()
                                                      .replace(".", ",")
                                                : "-"
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Status de Aprovação",
                                  width: "170",
                                  align: "center"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center justify-content-center"
                                          },
                                          [
                                            (scope.row.tipo_proposta ==
                                              "BONIFICACAO" ||
                                              scope.row.tipo_proposta ==
                                                "REQUISICAO" ||
                                              scope.row.tipo_proposta ==
                                                "AMOSTRA_DISTRIBUIDOR" ||
                                              scope.row.tipo_proposta ==
                                                "AMOSTRA") &&
                                            scope.row.aprovado
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-center"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v("APROVADO POR: ")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass: "m-0",
                                                        staticStyle: {
                                                          "font-size": "12px"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .aprovador.name
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : (scope.row.tipo_proposta ==
                                                  "BONIFICACAO" ||
                                                  scope.row.tipo_proposta ==
                                                    "AMOSTRA") &&
                                                !scope.row.aprovado
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-center"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v("AGUARDANDO")
                                                    ])
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-center"
                                                  },
                                                  [_c("span", [_vm._v("-")])]
                                                )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c(
                                "el-table-column",
                                {
                                  attrs: {
                                    prop: "acoes",
                                    width: "160",
                                    fixed: "right",
                                    align: "right"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-between"
                                            },
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  staticClass: "item",
                                                  attrs: {
                                                    effect: "light",
                                                    content:
                                                      scope.row.status !=
                                                      "APROVADO"
                                                        ? "Editar proposta"
                                                        : "Visualizar proposta",
                                                    placement: "bottom-end"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        size: "mini",
                                                        type:
                                                          scope.row.status !=
                                                          "APROVADO"
                                                            ? "warning"
                                                            : "primary",
                                                        plain: "",
                                                        circle: "",
                                                        disabled: _vm.isLoading
                                                      },
                                                      nativeOn: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.editar(
                                                            scope.row.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      scope.row.status !=
                                                      "APROVADO"
                                                        ? _c("i", {
                                                            staticClass:
                                                              "fa fa-edit"
                                                          })
                                                        : _c("i", {
                                                            staticClass:
                                                              "el-icon-right"
                                                          })
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  staticClass: "item",
                                                  attrs: {
                                                    effect: "light",
                                                    content:
                                                      "Imprimir proposta",
                                                    placement: "bottom-end"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        size: "mini",
                                                        plain: "",
                                                        circle: "",
                                                        disabled: _vm.isLoading
                                                      },
                                                      nativeOn: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.imprimir(
                                                            scope.row.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-print"
                                                      })
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              scope.row.status !== "CANCELADO"
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        effect: "light",
                                                        content:
                                                          "Copiar proposta",
                                                        placement: "bottom-end"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            size: "mini",
                                                            type: "success",
                                                            plain: "",
                                                            circle: "",
                                                            disabled:
                                                              _vm.isLoading
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.copiar(
                                                                scope.row.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-copy"
                                                          })
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              scope.row.pedido
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        effect: "light",
                                                        content:
                                                          "Espelho do pedido",
                                                        placement: "bottom-end"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            size: "mini",
                                                            type: "info",
                                                            plain: "",
                                                            circle: "",
                                                            disabled:
                                                              _vm.isLoading
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.imprimirPedido(
                                                                scope.row.pedido
                                                                  .id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-file-alt"
                                                          })
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              scope.row.status != "APROVADO"
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        effect: "light",
                                                        content:
                                                          "Excluir proposta",
                                                        placement: "bottom-end"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            size: "mini",
                                                            type: "danger",
                                                            plain: "",
                                                            circle: "",
                                                            disabled:
                                                              _vm.isLoading
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.destroy(
                                                                scope.row.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-trash"
                                                          })
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { slot: "header" },
                                      slot: "header"
                                    },
                                    [_c("i", { staticClass: "el-icon-menu" })]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c("el-empty", {
                        attrs: { description: "Nenhum distribuidor disponível" }
                      })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "el-col",
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          "current-page": _vm.filtro.currentPage,
                          "page-sizes": [15, 50, 75, 100],
                          "page-size": _vm.filtro.perPage,
                          layout: "total, sizes, prev, pager, next",
                          total: _vm.filtro.total
                        },
                        on: {
                          "update:currentPage": function($event) {
                            return _vm.$set(_vm.filtro, "currentPage", $event)
                          },
                          "update:current-page": function($event) {
                            return _vm.$set(_vm.filtro, "currentPage", $event)
                          },
                          "current-change": _vm.getPropostas,
                          "size-change": _vm.handleSizeChange
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d75ef44", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d75ef44","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/varejo/propostas/lista.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2d75ef44","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/varejo/propostas/lista.vue
// module chunks = 2